import React from 'react';
import { Box, Skeleton, useTheme } from '@ublend-npm/aulaui-core';

type UpcomingAssignmentRowSkeletonProps = {
  showDivider?: boolean;
};

/**
 * Loading placeholder that mirrors UpcomingAssignmentRow layout:
 * avatar | (title + course + term + due date chip) | status
 */
const UpcomingAssignmentRowSkeleton = ({
  showDivider = true,
}: UpcomingAssignmentRowSkeletonProps) => {
  const { palette } = useTheme();

  return (
    <Box
      display="flex"
      alignItems="flex-start"
      gap={2}
      sx={{
        borderBottom: showDivider ? `1px solid ${palette.divider}` : 'none',
        mb: showDivider ? '12px' : 0,
      }}
    >
      <Box
        display="flex"
        alignItems="flex-start"
        gap={2}
        sx={{
          minWidth: 0,
          width: '100%',
          p: '8px',
          mb: '8px',
        }}
      >
        <Skeleton kind="circular" width={40} height={40} />

        <Box flex={1} minWidth={0} display="flex" gap={1}>
          <Box
            flex={1}
            minWidth={0}
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
          >
            <Skeleton kind="text" width="70%" height={24} />
            <Skeleton kind="text" width="55%" height={20} sx={{ mt: 0.5 }} />
            <Skeleton kind="text" width="45%" height={20} />
            <Skeleton
              kind="rounded"
              width={120}
              height={20}
              sx={{ mt: 1, borderRadius: '16px' }}
            />
          </Box>

          <Box
            display="flex"
            alignItems="flex-start"
            flexShrink={0}
            sx={{ pt: '8px', pr: '8px' }}
          >
            <Skeleton kind="circular" width={8} height={8} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default UpcomingAssignmentRowSkeleton;
